import React from 'react';
import './main.css'

function Main1() {
    return ( <>

     <ul>
     <details>
            <summary>Network with Success:</summary>
            <p>Connect with fellow students, alumni, and <br />
            industry leaders to build your professional network.</p>
            
        </details>    
     <details>
            <summary>Expert-Led Education: </summary>
            <p> Learn from industry professionals with <br />
            proven track records in real estate investing.</p>
        </details>
        <details>
            <summary>Privacy 🔏 </summary>
            <p>No information sharing and</p> 
            <p> maximum discretion.</p>
        </details>
        <details>
            <summary>Hands-On Learning: </summary>
            <p>Go beyond theory with practical workshops, <br />
                simulations, and real-world case studies.</p>
        </details>    
        <details>
            <summary>Investment Opportunities: 🧾</summary>
            <p>Get exclusive access to pre-vetted real estate 
            <br />investment options tailored for students.</p>
        </details>    
        <details>
            <summary>Become an Altero Member: 🔖 </summary>
            <p>Sign up for free and unlock exclusive <br />
            educational  resources and investment <br />opportunities.</p>
        </details>  
     </ul>
    </> );
}

export default Main1;